<div class="seccion-indicador-pregunta">
  <p class="texto-indicador-pregunta">
    {{ pregunta }}
  </p>
  <div class="formulario-respuesta-indicador-pregunta">
    <form [formGroup]="form">
      <ion-radio-group
        [formControlName]="controlName"
        class="radio-group-indicador-pregunta"
        (ionChange)="cambioValor($event)"
      >
        <ion-item
          lines="none"
          class="radio-item"
          (keydown)="opcionSeleccionada($event, true)"
        >
          <ion-radio [value]="true" labelPlacement="end" justify="start"
            >Si</ion-radio
          >
        </ion-item>
        <ion-item
          lines="none"
          class="radio-item"
          (keydown)="opcionSeleccionada($event, false)"
        >
          <ion-radio [value]="false" labelPlacement="end" justify="start"
            >No</ion-radio
          >
        </ion-item>
      </ion-radio-group>
    </form>
  </div>
</div>
